import { render, staticRenderFns } from "./relatorioDinamico.vue?vue&type=template&id=6d947d16"
import script from "./relatorioDinamico.vue?vue&type=script&lang=js"
export * from "./relatorioDinamico.vue?vue&type=script&lang=js"
import style0 from "./relatorioDinamico.vue?vue&type=style&index=0&id=6d947d16&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports